import {
    CREATE_STYLE_MASTER_BASIC_REQUEST,
    CREATE_STYLE_MASTER_BASIC_SUCCESS,
    CREATE_STYLE_MASTER_BASIC_FAILURE,
    DELETE_STYLE_MASTER_BASIC_REQUEST,
    DELETE_STYLE_MASTER_BASIC_SUCCESS,
    DELETE_STYLE_MASTER_BASIC_FAILURE,
    FETCH_SINGLE_STYLE_MASTER_BASIC_REQUEST,
    FETCH_SINGLE_STYLE_MASTER_BASIC_SUCCESS,
    FETCH_SINGLE_STYLE_MASTER_BASIC_FAILURE,
    FETCH_STYLE_MASTER_BASIC_REQUEST,
    FETCH_STYLE_MASTER_BASIC_SUCCESS,
    FETCH_STYLE_MASTER_BASIC_FAILURE,
    UPDATE_STYLE_MASTER_BASIC_REQUEST,
    UPDATE_STYLE_MASTER_BASIC_SUCCESS,
    UPDATE_STYLE_MASTER_BASIC_FAILURE,
    RESET_STYLE_MASTER_BASIC_INFO,
    CREATE_STYLE_MASTER_BASIC_FORM,
    UPDATE_STYLE_MASTER_BASIC_FORM,
    NAVIGATE_STYLE_MASTER_BASIC,
    NAVIGATE_STYLE_SKU_MASTER,
    FETCH_STYLE_MASTER_BASIC_WITH_SKU_REQUEST,
    FETCH_STYLE_MASTER_BASIC_WITH_SKU_SUCCESS,
    FETCH_STYLE_MASTER_BASIC_WITH_SKU_FAILURE
} from './styleMasterBasic.actionsType';

export const STYLE_MASTER_BASIC = 'styleMasterBasic';

let initialState = {
    loading: false,
    styleMasterBasic: [],
    styleMasterBasicWithSKU: [],
    styleMasterBasicForm: {
        fldWithSKU: false
    },
    selectedState: {},
    errorMessage: '',
    singleStyleMasterBasic: {},
    isSkuMaster: false
};

export let styleMasterBasicReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_STYLE_MASTER_BASIC_REQUEST:
        case FETCH_STYLE_MASTER_BASIC_WITH_SKU_REQUEST:
        case CREATE_STYLE_MASTER_BASIC_REQUEST:
        case UPDATE_STYLE_MASTER_BASIC_REQUEST:
        case FETCH_SINGLE_STYLE_MASTER_BASIC_REQUEST:
        case DELETE_STYLE_MASTER_BASIC_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_STYLE_MASTER_BASIC_SUCCESS:
            return {
                ...state,
                loading: false,
                styleMasterBasic: updatePayload
            };
        case FETCH_STYLE_MASTER_BASIC_WITH_SKU_SUCCESS:
            return {
                ...state,
                loading: false,
                styleMasterBasicWithSKU: updatePayload
            };
        case CREATE_STYLE_MASTER_BASIC_SUCCESS:
            return {
                ...state,
                loading: false,
                styleMasterBasicForm: {
                    fldWithSKU: false
                }
            };
        case UPDATE_STYLE_MASTER_BASIC_SUCCESS:
            return {
                ...state,
                loading: false,
                styleMasterBasicForm: {
                    fldWithSKU: false
                }
            };
        case FETCH_SINGLE_STYLE_MASTER_BASIC_SUCCESS:
            return {
                ...state,
                loading: false,
                styleMasterBasicForm: updatePayload
            };
        case DELETE_STYLE_MASTER_BASIC_SUCCESS:
            return {
                ...state,
                loading: false,
                styleMasterBasicForm: {
                    fldWithSKU: false
                }
            };
        case RESET_STYLE_MASTER_BASIC_INFO:
            return {
                ...state,
                styleMasterBasicForm: {
                    fldWithSKU: false
                }
            };
        case CREATE_STYLE_MASTER_BASIC_FORM:
        case UPDATE_STYLE_MASTER_BASIC_FORM:
            return {
                ...state,
                loading: false,
                styleMasterBasicForm: {
                    ...state.styleMasterBasicForm,
                    [payload.key]: payload.value
                }
            };
        case FETCH_STYLE_MASTER_BASIC_FAILURE:
        case FETCH_STYLE_MASTER_BASIC_WITH_SKU_FAILURE:
        case CREATE_STYLE_MASTER_BASIC_FAILURE:
        case UPDATE_STYLE_MASTER_BASIC_FAILURE:
        case FETCH_SINGLE_STYLE_MASTER_BASIC_FAILURE:
        case DELETE_STYLE_MASTER_BASIC_FAILURE:
            return {
                ...state,
                loading: false
            };
        case NAVIGATE_STYLE_SKU_MASTER:
            return {
                ...state,
                isSkuMaster: true,
                singleStyleMasterBasic: updatePayload.singleStyleMasterBasic
            };
        case NAVIGATE_STYLE_MASTER_BASIC:
            return {
                ...state,
                isSkuMaster: false
            };
        default:
            return state;
    }
};
